module.exports = __webpack_public_path__ + "static/media/decode-logo.abbc53f7.svg";